import {
  isRequired, // eslint-disable-line
  number,
  string,
} from "prop-types";

export default {
  id: number,
  start: string,
  end: string,
  title: string.isRequired,
};
